module.exports = __webpack_public_path__ + "78e1787f0dcdc659c9399ffc0065676e.svg";